import styled from 'styled-components';

const EmptyQuestionContainer = styled.div`
  position: ${({ type }) =>
    type === 'not-selected' ? 'absolute' : 'relative'};
  height: ${({ type }) => (type === 'not-selected' ? '500px' : '100%')};
  top: ${({ type }) => (type === 'not-selected' ? '50%' : '0%')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const EmptyOuestionTextOne = styled.div`
  padding: 0.5rem 1rem;
  color: #42526e;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
`;

const EmptyOuestionTextTwo = styled.div`
  padding: 0.5rem 1rem;
  color: #5267ff;
  text-align: center;
  text-decoration: ${({ isClickable }) => (isClickable ? 'underline' : 'none')};
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
`;

export { EmptyQuestionContainer, EmptyOuestionTextOne, EmptyOuestionTextTwo };
